const factory = (LedgerCategoryOrder, Collection) => {
  class LedgerCategoryOrderCollection extends Collection {
    constructor(clientId = null) {
      super(clientId);

      this.clientId = clientId;
    }

    $init() {
      if (this.$lastUpdated === 0) {
        this.$fetch();
      }
    }

    $url() {
      return `${this.$resource}.json/order/client/${this.$storeId()}`;
    }
  }

  LedgerCategoryOrderCollection.prototype.$resource = 'ledgeraccountcategory';
  LedgerCategoryOrderCollection.prototype.$type = LedgerCategoryOrder;
  LedgerCategoryOrderCollection.prototype.$idName = 'clientId';
  LedgerCategoryOrderCollection.prototype.$$cacheModels = true;
  LedgerCategoryOrderCollection.prototype.$useCachedModels = true;

  return LedgerCategoryOrderCollection;
};

const moduleDeps = [require('data/model/ledgerCategoryOrder').name, require('data/util').name];

module.exports = angular
  .module('bench.data.collection.ledgerCategoryOrder', moduleDeps)
  .factory('LedgerCategoryOrderCollection', factory);
